
import { Dispatch } from "redux";
import { GET_PARAMS } from "./paramHelper";

export const RECEIVE_VR_REPORT_ONGOING = 'RECEIVE_VR_REPORT_ONGOING'

export interface VrReportOngoing {
  type: string;
  pbse_version: string;
  is_usa: boolean;
  count: string;
}

export const fetchVrReportsOngoing = (token: string) => async (dispatch: Dispatch) => {
  return await fetch("/api/vrreports_ongoing/", GET_PARAMS(token)).then(async response => {
    const { vrReportsOngoing }: { vrReportsOngoing: VrReportOngoing[] } = await response.json();

    return dispatch({
      type: RECEIVE_VR_REPORT_ONGOING,
      vrReportsOngoing
    });
  });
};